import React from 'react';

import { NoteDisplay } from '../NoteDisplay.tsx';
import { useActionPromptContext } from './ActionPromptContext.tsx';

export const NoteSection: React.FC = () => {
  const { currentStatus, step } = useActionPromptContext();

  return <NoteDisplay stepId={step.id} noteConfig={currentStatus?.note} prefix="Note" />;
};
